import React from "react";
import { getThemeProperties } from "../../../DashboardPage/getThemeProperties";

/**
 * TitleWithIcon component displays a title with an optional icon or a colored shape.
 * 
 * @param {Object} props - Component props
 * @param {string} [props.id] - ID for the colored shape
 * @param {string} [props.title] - Title text
 * @param {string} [props.icon] - FontAwesome icon name (e.g., 'star')
 * @param {string} [props.color] - Color for the icon or shape
 * @param {Object} [props.style] - Custom styles for the title header
 * @param {Object} [props.prefixStyle] - Custom styles for the colored shape
 * @param {Object} [props.titleStyle] - Custom styles for the title content
 * @param {string} [props.className] - CSS class for the title header
 * @param {string} [props.prefixClassName] - CSS class for the colored shape
 * @param {string} [props.titleClassName] - CSS class for the title content
 * @param {boolean} [props.comesFromDashboardArea] - Whether the component is used in the dashboard area
 * @param {boolean} [props.isHovered] - Whether the component is being hovered (used with comesFromDashboardArea)
 */
const TitleWithIcon = ({
  id,
  title,
  icon,
  color,
  style,
  prefixStyle,
  titleStyle,
  className,
  prefixClassName,
  titleClassName,
  comesFromDashboardArea,
  isHovered
}) => {
  const renderPrefix = () => {
    if (icon) {
      return (
        <i
          className={`far fa-${icon}`}
          style={{
            fontSize: "18px",
            position: "relative",
            color: color || "inherit",
            ...prefixStyle
          }}
        />
      );
    }

    if (color) {
      return (
        <span
          id={id}
          className={prefixClassName}
          style={{
            backgroundColor: color,
            ...prefixStyle
          }}
        />
      );
    }

    return (
      <span
        id={id}
        className={prefixClassName}
        style={{
          backgroundColor: "transparent",
          ...prefixStyle
        }}
      />
    );
  };

  return (
    <h4
      className={className}
      style={{
        display: "flex",
        alignItems: "center",
        fontSize: 16,
        margin: 0,
        gap: 8,
        ...style
      }}
    >
      {renderPrefix()}
      <span
        className={titleClassName}
        style={{
          margin: 0,
          color: comesFromDashboardArea
            ? (isHovered ? getThemeProperties("backgroundColor") : getThemeProperties("textColor"))
            : "inherit",
          ...titleStyle
        }}
      >
        {title}
      </span>
    </h4>
  );
};

export default TitleWithIcon;